import { HttpClient } from '@/shared';
import EmployerLocation from '../../application/domain/entities/employerLocation';
import EmployerState from '../../application/domain/entities/employerState';
import StateCity from '../../application/domain/entities/stateCity';
import Account from '../../application/domain/entities/account';
import IEmployeeInfoRepository from '../../application/ports/outbound/IEmployerRepository';
import LocationDto from '../dto/req/locationDto';
import StateDto from '../dto/req/stateDto';
import AccountDto from '../dto/req/accountDto';
import AddressResDto from '../dto/res/addressResDto';
import {
  mapLocationDtoToLocation,
  mapAddressResToStateCity,
  mapStateDtoToState,
  mapAccountDtoToAccount,
} from '../mapper/employeeInfoMapper';

const mock: boolean = false;
export class ApiEmployerRepository implements IEmployeeInfoRepository {
  constructor(private readonly httpClient: HttpClient) { }
  async fetchStates(): Promise<EmployerState[]> {
    // Mocked list
    const stateDto: StateDto[] = [
      { stateId: '1', shortForm: 'CA', name: 'California' },
      { stateId: '2', shortForm: 'NY', name: 'New York' },
      { stateId: '3', shortForm: 'TX', name: 'Texas' },
    ];
    if (mock) {
      return new Promise((res) => setTimeout(() => res(stateDto.map(mapStateDtoToState)), 150));
    }
    const states = await this.httpClient.get<Array<StateDto>>('/state');
    return states.data.map(mapStateDtoToState);
  }

  async fetchEmployerLocations(accountId: string): Promise<EmployerLocation[]> {
    // Mocked employer locations
    const dto: LocationDto[] = [
      {
        locationId: `LOC-${accountId}-1`,
        name: `California HQ`,
        state: { stateId: '1', shortForm: 'CL', name: `California` },
      },
      {
        locationId: `LOC-${accountId}-2`,
        name: `New York Remote`,
        state: { stateId: '2', shortForm: 'NY', name: `New York` },
      },
      {
        locationId: `LOC-${accountId}-3`,
        name: `New York Work Station`,
        state: { stateId: '2', shortForm: 'NY', name: `New York` },
      },
    ];

    if (mock) {
      return new Promise((res) => setTimeout(() => res(dto.map(mapLocationDtoToLocation)), 500));
    }
    const locations = await this.httpClient.get<Array<LocationDto>>(
      `/account/${accountId}/locations`
    );
    return locations.data.map(mapLocationDtoToLocation);
  }

  async fetchStateCityByZipcode(zipcode: string): Promise<StateCity | null> {
    // Backend infers the country and resolves city/state from the postal code.
    // Response envelope is { statusCode, message, data }; HttpClient returns the envelope,
    // so the address payload is on `res.data`.
    const res = await this.httpClient.get<AddressResDto>('/address', {
      params: { postalCode: zipcode },
    });
    return res?.data ? mapAddressResToStateCity(res.data) : null;
  }

  async searchAccounts(searchKey: string, signal?: AbortSignal): Promise<Account[]> {
    const accounts = await this.httpClient.get<Array<AccountDto>>(
      `/account?searchKey=${searchKey}`,
      { signal }
    );
    return accounts.data.map(mapAccountDtoToAccount);
  }
}

export default ApiEmployerRepository;
